import React from 'react'
import { Bar, BarChart, Legend, ResponsiveContainer, XAxis, YAxis } from 'recharts'
import * as colors from '../../assets/js/colors'
import CustomCard from '../CustomCard/CustomCard'

export default function CustomHorizontalBarChart({ title, items, borderTopColor, label }) {
  return (
    <CustomCard title={title} style={{ borderTop: `5px solid ${borderTopColor}` }}>
      {items.length === 0 ? (
        <h5>Não Existe Ocorrências</h5>
      ) : (
        <div style={{ height: 130 }}>
          <ResponsiveContainer>
            <BarChart
              data={items}
              layout="vertical"
              barCategoryGap={1}
              margin={{ top: 0, right: 50, left: 0, bottom: 0 }}
            >
              <XAxis type="number" hide />
              <YAxis type="category" width={60} padding={{ left: 50 }} dataKey="name" />
              <Legend
                formatter={(value, entry, index) => value[0].toUpperCase() + value.substring(1)}
              />
              <Bar
                dataKey="totais"
                fill={colors.azul_claro}
                barSize={32}
                label={{ fill: 'black', fontSize: 20 }}
              />
              <Bar
                dataKey="parciais"
                fill={colors.azul}
                barSize={32}
                label={{ fill: 'black', fontSize: 20 }}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </CustomCard>
  )
}
